/**
 * Author: wangchengfeng@immusician.com
 * Datetime: 2020/8/3 下午4:17
 */

import React from 'react';
import Waiting from './Waiting';
import Error2 from './Error2';
import { Form, Table, FormControl, FormGroup, ControlLabel } from 'react-bootstrap';
import ThePagination from './Pagination';
import * as api from '../api';
import ElementView from './ElementView';
import { Link } from 'react-router-dom';
export default class HuaweiPay extends React.Component {
    constructor(props) {
        super(props);
        this.onLoad = this.onLoad.bind(this);
        this.state = {
            loading: false,
            error: null,
            studies: [],
            page: 0,
            size: 10,
            total: 0,
            phone: '',
            order_id: '',
            instrument_type: 'ukulele',
            instype: ''
        };
    }

    onLoad() {
        const {
            location: { search }
        } = this.props;
        const params = new URLSearchParams(search.replace('?', ''));
        const { page, size, phone, order_id, instrument_type, instype } = this.state;
        //this.setState({loading: true, error: null});
        // api.getCourseStudies({page, size, phone, instype, courseId: params.get('courseId'), lessonId: params.get('lessonId'), userId: params.get('userId')})
        //     .then(json => this.setState({
        //         loading: false,
        //         studies: json.data,
        //         total: json.paging.total,
        //     }))
        //     .catch(error => this.setState({
        //         loading: false,
        //         error: error
        //     }))
        if (phone || order_id) {
            this.setState({ loading: true, error: null });
            api.getHuaweiPayOrders({ phone, order_id })
                .then((json) => {
                    this.setState({
                        loading: false,
                        studies: json.data
                    });
                    // console.log('---');
                    // console.log(this.state);
                })
                .catch((error) =>
                    this.setState({
                        loading: false,
                        error: error
                    })
                );
        }
    }

    componentDidMount() {
        this.onLoad();
    }

    render() {
        const {
            loading,
            error,
            studies,
            page,
            size,
            total,
            phone,
            order_id,
            instrument_type,
            instype
        } = this.state;
        return (
            <div style={{ marginTop: 5 }}>
                <Waiting isVisible={loading} />
                <Error2 error={error} onOk={() => this.setState({ error: null })} />

                <Form inline style={{ marginBottom: 5, padding: 3, marginTop: 10 }}>
                    <input
                        ref="phone"
                        type="text"
                        value={phone}
                        className="form-control input-sm"
                        placeholder="请输入手机号"
                        onChange={(e) => this.setState({ phone: e.target.value.trim() })}
                    />
                    &nbsp;
                    <input
                        style={{ width: '300px' }}
                        ref="order_id"
                        type="text"
                        value={order_id}
                        className="form-control input-sm"
                        placeholder="请输入订单编号"
                        onChange={(e) => this.setState({ order_id: e.target.value.trim() })}
                    />
                    &nbsp;
                    <button
                        className="btn btn-success btn-sm"
                        onClick={(e) => {
                            e.preventDefault();
                            this.onLoad();
                        }}
                    >
                        搜索
                    </button>
                    &nbsp;&nbsp;
                    {/* <FormGroup bsSize="small" controlId="days" value={instype}
                               onChange={e => this.setState({instype: e.target.value == "" ? null : e.target.value}, this.onLoad)}>
                        <ControlLabel>乐器类型：</ControlLabel>
                        <FormControl componentClass="select">
                            <option value="">全部</option>
                            <option value="0">吉他</option>
                            <option value="1">尤克里里</option>
                            <option value="2">卡林巴</option>
                        </FormControl>
                    </FormGroup> */}
                </Form>

                <Table bordered hover striped condensed responsive>
                    <thead>
                        <tr>
                            <th>订单编号</th>
                            <th>手机号</th>
                            <th>uid</th>
                            <th>金额</th>
                            <th>商品名称</th>
                            <th>sku</th>
                            <th>支付方式</th>
                            <th>支付状态</th>
                            <th>购买时间</th>
                        </tr>
                    </thead>
                    <tbody>
                        {studies.map((study, index) => {
                            return (
                                <tr key={index}>
                                    <td>{study.payOrderId}</td>
                                    <td>{`${study.phone}`}</td>
                                    <td>{`${study.uid}`}</td>
                                    <td>{`${study.price / 100}`}</td>
                                    <td>{`${study.productName}`}</td>
                                    <td>{`${study.sku}`}</td>
                                    <td>{`${study.payType}`}</td>
                                    <td>{`${study.pay_state}`}</td>
                                    {/* <td>
                                            {
                                                (() => {
                                                    let query = [];
                                                    if (study.course) {
                                                        query.push(['courseId', study.course.id]);
                                                    }
                                                    if (study.user) {
                                                        query.push(['userId', study.user.id]);
                                                    }
                                                    return (
                                                        <Link
                                                            to={`plays?${query.map(x => x.join('=')).join('&')}`}>{study.playedCount}</Link>
                                                    );
                                                })()
                                            }
                                        </td>
                                        <td>{study.remark}</td>
                                        <td><ElementView type="timestamp" value={study.firstStudiedAt} /></td> */}
                                    <td>
                                        <ElementView type="timestamp" value={study.purchaseTime} />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
                <ThePagination
                    page={page}
                    size={size}
                    total={total}
                    onSelect={(page) => this.setState({ page }, this.onLoad)}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// src/components/HuaweiPay.js